<div class="content-area">
  <div class="row pt-3">
    <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 mx-auto">
      <div class="back-btn-container pointer" (click)="goBack()">
        <img class="back-arrow" src="assets/images/back-arrow.png" />
        Back
      </div>
      <div class="card shadow text-start p-2">
        <div class="card-body p-5 p-2-mobile">
          <div class="selected-plan-card" *ngIf="selectedPlan">
            <div class="selected-plan-info">
              <div class="selected-plan-label">Selected Plan</div>
              <div class="selected-plan-summary">
                <ng-container *ngIf="selectedPlan.quotaCalls">{{ selectedPlan.quotaCalls | number }} Calls/Month • </ng-container>{{ selectedPlan.currencySymbol }}{{ selectedPlan.pricePerMonth | number: '1.0-0' }}/mo
              </div>
              <div class="selected-plan-sub" *ngIf="selectedPlan.quotaCalls">
                {{ selectedPlan.quotaCalls | number }} calls/month
              </div>
            </div>
            <i class="bi bi-telephone selected-plan-icon" aria-hidden="true"></i>
          </div>

          <h4 class="card-title text-center">Let's get started</h4>
          <p class="card-text mb-4 text-center">
            Create your First Orion business account
          </p>

          <form
            [formGroup]="registerForm"
            (ngSubmit)="onSubmit()"
            autocomplete="off"
          >
            <!-- First Row: First Name & Last Name -->
            <div class="row mb-3 mt-3">
              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                <label for="firstName" class="form-label">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  formControlName="firstName"
                  required
                  [ngClass]="{ 'is-invalid': isFieldInvalid('firstName') }"
                />
                <div class="field-error" *ngIf="isFieldInvalid('firstName')">
                  Enter a valid first name.
                </div>
              </div>
              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                <label for="lastName" class="form-label">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  formControlName="lastName"
                  required
                  [ngClass]="{ 'is-invalid': isFieldInvalid('lastName') }"
                />
                <div class="field-error" *ngIf="isFieldInvalid('lastName')">
                  Enter a valid last name.
                </div>
              </div>
              <div
                class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3"
              >
                <label for="email" class="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  class="form-control"
                   maxlength="128"
                />
                <div class="field-error" *ngIf="isFieldInvalid('email')">
                  Enter a valid email.
                </div>
              </div>
              <div
                class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3"
              >
                <label for="password" class="form-label">Password</label>
                <input
                  [type]="hide ? 'password' : 'text'"
                  id="password"
                  formControlName="password"
                  class="form-control password-field"
                  minlength="8"
                  maxlength="16"
                />
                <i
                  class="fa fa-eye eye-btn pointer"
                  *ngIf="hide"
                  aria-hidden="true"
                  (click)="toggleVisibility()"
                ></i>
                <i
                  class="fa fa-eye-slash eye-btn pointer"
                  *ngIf="!hide"
                  aria-hidden="true"
                  (click)="toggleVisibility()"
                ></i>
                <div
                  *ngIf="registerForm.get('password')?.value"
                  class="strength-row"
                >
                  <div class="strength-label">
                    <span>Password strength:</span>
                    <span
                      id="pw-strength-text"
                      class="strength-text"
                      [ngClass]="progressClass"
                    >
                      {{ strengthLabel === "Empty" ? "" : strengthLabel }}
                    </span>
                  </div>
                  <div class="meter" aria-hidden="true">
                    <div class="meter-bg">
                      <div
                        class="meter-fill"
                        [ngClass]="progressClass"
                        [style.width.%]="progressPercent"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="field-error" *ngIf="isFieldInvalid('password')">
                  {{ getPasswordErrorMessage() }}
                </div>
              </div>
              <div class="terms-text pb-2">
                Please read and accept Branded Calling Services Terms to create
                an account.
              </div>
              <div
                class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-2"
              >
                <app-terms-checkbox
                  formControlName="termsStatus"
                ></app-terms-checkbox>
              </div>

              <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="text-start-end mt-2 mb-2">
                  <button
                    type="submit"
                    class="btn btn-secondary w-100"
                    [disabled]="
                      registerForm.invalid || !captchaToken || isPasswordTooWeak
                    "
                  >
                    Next
                  </button>
                  <p class="text-center text-muted mt-3 text-account">
                    Already have an account?
                    <a href="javascript:;" class="btn-link" (click)="login()">
                      Log In
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <!-- Last Row: Submit Button -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
